<template>
    <div class="enrollment">
        <div class="information">
            <div class="columns">
                <div class="column is-narrow is-hidden-touch">
                    <i class="fad fa-chalkboard-teacher has-text-primary fa-2x"></i>
                </div>
                <div class="column">
                    <div class="columns is-block-tablet is-flex-widescreen">
                        <div class="column">
                            <div class="has-text-weight-bold">
                                <i class="fad fa-chalkboard-teacher has-text-primary is-hidden-desktop mr-2"></i>
                                {{ enrollment.name }}
                            </div>
                            <div class="enrollment-meta mb-3" v-if="enrollment.customName">
                                {{ enrollment.customName }}
                            </div>
                            <div class="enrollment-meta mb-3">
                                Washington State Professional Development (Clock Hours)
                            </div>
                            <div v-if="!enrollment.completed">
                                <b-progress type="is-primary" size="" :value="(enrollment.completedUnits/enrollment.units)*100" class="enroll-progress mr-6"/>
                                <div class="enrollment-meta has-text-grey">{{ enrollment.completedUnits.toFixed(2) }} of {{ enrollment.units }} clock hours. ({{ ((enrollment.completedUnits / enrollment.units) * 100).toFixed(0) }}%).</div>
                            </div>
                            <div v-else>
                                <div class="enrollment-meta has-text-grey"><i class="far fa-check-circle mr-2 has-text-success"></i>Completed on {{ enrollment.completedDate | moment('MMMM Do, YYYY') }}.</div>
                            </div>
                        </div>
<!--                        <div class="column has-text-right is-narrow">-->
<!--                            <div v-if="!enrollment.completed">-->
<!--                                <router-link :to="'/course/' + enrollment.id + '/true'">-->
<!--                                    <b-button type="is-primary" size="" expanded><i class="fas fa-pencil mr-2"></i>Open Course</b-button>-->
<!--                                </router-link>-->
<!--                            </div>-->
<!--                            <div v-else>-->
<!--                                &lt;!&ndash;                        <router-link v-else :to="'/legacy/' + enrollment.id">&ndash;&gt;-->
<!--                                &lt;!&ndash;                            <b-button type="is-primary" outlined size="" expanded class="mb-2"><i class="fas fa-eye mr-2"></i>Review Course</b-button>&ndash;&gt;-->
<!--                                &lt;!&ndash;                        </router-link>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="column has-text-right is-narrow">
                            <b-button tag="a" type="is-primary" :href="'https://www.my247ed.com/account/doAppLogin.php?u=' + currentUser.email + '&h=' + currentUser.legacy_hash + '&r=/account/enrollments'">Visit Legacy Site<i class="fad fa-arrow-up-right-from-square ml-3"></i></b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="legacy">
            <b-message type="is-warning">
                <div class="columns is-gapless">
                    <div class="column is-narrow"><i class="fas fa-info-circle fa-fw mr-3 has-text-warning"></i></div>
                    <div class="column">
                        <div class="is-size-7-mt-3">This <strong>Legacy Course</strong> is available on our <strong>Legacy Site</strong>. Please access it from there.</div>
                    </div>
                </div>
            </b-message>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "ClassicEnrollment",
        props: {
            enrollment: {
                required: true
            }
        },
        computed: {
            ...mapGetters(['currentUser'])
        }
    };
</script>

<style lang="scss" scoped>
    .enrollment {
        background-color: white;
        border-radius: 4px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.4);

        .information {
            padding: 1.5rem 1.5rem 1rem;
        }

        .enrollment-meta {
            font-size: 0.9rem;
        }


    }
</style>

<style lang="scss">
    .enroll-progress {
        margin-bottom: 0.2rem !important;

        .progress {
            height: 0.25rem !important;
        }
    }

    .legacy {
        padding: 0 1.5rem 20px 1.8rem;

        .message-body {
            font-size: 0.9rem;
        }
    }
</style>
